import React from 'react';
import { get } from 'lodash';
import Grid from '../../molecules/Grid';

import CarouselCard from '../../../components/molecules/CarouselCard';
import useStyles from './style';
import Typography from '../../atoms/Typography';

const EventPartners = ({ data, title }) => {
  const eventList = get(data, 'fields.collageType1Items', []);
  const classes = useStyles();
  return (
    <div className='eventPartnersWrapper'>
      {
        title && (
          <Grid item xs={12} className='segment-title'>
            <Typography
              variant="h4"
              component="h2"
              className={classes.title}
            >
              {title}
            </Typography>
          </Grid>
        )
      }
      <Grid container classes={{ root: classes.eventPartnerContainer }}>
        {eventList && eventList.length > 0 && eventList.map(item => {
          return (
            <Grid item lg={4} classes={{ root: classes.eventPartnerCard }} key={item}>
              <CarouselCard
                sectionTitle={title}
                title={get(item, 'fields.title', '')}
                desktopImage={get(item, 'fields.desktopImage', '')}
                mobileImage={get(item, 'fields.mobileImage', '')}
                ctaLink={get(item, 'fields.attributeLabelCTA', [])}
                imageCtaUrl={get(item, 'fields.primaryCTA', '')}
                startDate={get(item, 'fields.startDate', '')}
                locationTitle={get(item, 'fields.locationTitle.value', '')}
                region={get(item, 'fields.region.value', '')}
                endDate={get(item, 'fields.endDate', '')}
                openTime={get(item, 'fields.openTime', '')}
                closeTime={get(item, 'fields.closeTime', '')}
                cardType={'event'}
                urlSlug={get(item, 'fields.urlSlug', '')}
              />
            </Grid>
          )
        })}
      </Grid>
    </div>
  )

}

export default EventPartners;

